export default {
  section: 'Contabilidad',
  loading: 'Cargando contabilidad...',
  headers: {
    uuid: 'UUID de la factura',
    folio: 'Folio',
    purchaseOrder: 'Orden de compra',
    provider: 'Proveedor',
    issuedAt: 'Fecha de facturación',
    invoiceDate: 'Fecha de recepción',
    amount: 'Monto'
  },
  labels: {
    invoiceDates: 'Fechas de facturación',
    provider: 'Proveedor',
    find: 'Buscar por uuid',
    downloadXML: 'Descargar XML de las facturas',
    download: 'Descargar contabilidad'
  },
  buttons: {
    downloadXML: 'Descargar XML de las facturas',
    accountingCSV: 'Descargar contabilidad'
  }
}
